module.exports = "/img/41.728cc1.webp";